import { render, staticRenderFns } from "./AutoUrlLink.vue?vue&type=template&id=f791b90c&"
import script from "./AutoUrlLink.vue?vue&type=script&lang=ts&"
export * from "./AutoUrlLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports